<template>
    <v-card dark>
        <v-overlay :value="loading" absolute opacity="0.85" class="overflow:hidden;">
            <v-progress-circular class="ma-3" indeterminate large color="secondary" />
        </v-overlay>
        <v-toolbar class="text-overline" dark>Seed Stock - By Category</v-toolbar>
        <v-card-text class="pa-0">
            <v-expansion-panels v-if="byCategory.length" readonly class="ss-expansion">
                <v-expansion-panel v-for="(category, i) in byCategory" :key="i">
                    <v-expansion-panel-header
                        class="ss-expansion-panel text-overline"
                        :color="selected.includes(category) ? 'success' : ''"
                        expand-icon=""
                        @click.stop=""
                    >
                        <v-switch v-model="selected" :value="category" inset @click.stop=""></v-switch>{{ category }}
                    </v-expansion-panel-header>
                    <!-- <v-expansion-panel-content class="pa-0" style="padding: 0px !important">
                        <v-data-table :headers="headers" :items="byCategory[category]">
                            <template v-slot:item.photo="{ item }">
                                <v-img
                                    max-width="75"
                                    style="display: block; margin: auto"
                                    :src="`https://rma.getac.com/${item.imgUrl}`"
                                />
                            </template>
                        </v-data-table>
                    </v-expansion-panel-content> -->
                </v-expansion-panel>
            </v-expansion-panels>
            <div v-else class="text-center pt-10 pb-5">
                <span>No categories available</span>
            </div>
        </v-card-text>
        <v-card-actions class="pt-5 pb-5">
            <v-btn elevation="0" text @click="$emit('cancel')">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#db5120" dark elevation="0" :disabled="!selected || !selected.length" @click="submitStock"
                >Submit</v-btn
            >
        </v-card-actions>
    </v-card>
</template>

<script>
import gql from 'graphql-tag'

export default {
    name: 'SeedStock',
    props: {
        confirmedCustomer: {
            type: Object,
            required: false,
            default: () => {}
        },
        confirmedCategories: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    apollo: {
        querySMCustomerCategories: {
            query: gql`
                query Query($customerId: String!) {
                    querySMCustomerCategories(customerId: $customerId)
                }
            `,
            variables() {
                return {
                    customerId: this.$auth.user.org.branchId
                }
            },
            update(data) {
                this.byCategory = data.querySMCustomerCategories
                this.loading = false
            }
        }
        // querySMInv: {
        //     query: gql`
        //         query Query {
        //             querySMInv {
        //                 model
        //                 partSpec
        //                 category
        //                 partNumber
        //                 invQty
        //                 smId
        //                 imgUrl
        //             }
        //         }
        //     `,
        //     update(data) {
        //         this.byCategory = this.groupByCategory(data.querySMInv)
        //     }
        // }
    },
    data() {
        return {
            loading: true,
            selected: this.confirmedCategories,
            byCategory: [],
            headers: [
                {
                    text: 'Photo',
                    align: 'center',
                    sortable: false,
                    value: 'photo'
                },
                {
                    text: 'Model',
                    align: 'start',
                    sortable: false,
                    value: 'model'
                },
                {
                    text: 'Part Spec',
                    value: 'partSpec',
                    sortable: false,
                    align: 'start'
                },
                {
                    text: 'Stock Balance',
                    value: 'invQty',
                    sortable: false,
                    align: 'center'
                }
            ]
        }
    },
    computed: {},
    methods: {
        groupByCategory(arr) {
            let result = []
            result = arr.reduce((r, a) => {
                r[a.category] = r[a.category] || []
                r[a.category].push(a)
                return r
            }, {})
            return result
        },
        submitStock() {
            this.loading = true
            const input = {
                confirmedCategories: this.selected,
                smConfirmed: true,
                address: this.confirmedCustomer.address,
                contact: {
                    company: this.confirmedCustomer.contact.company,
                    firstName: this.confirmedCustomer.contact.firstName,
                    lastName: this.confirmedCustomer.contact.lastName,
                    email: this.confirmedCustomer.contact.email,
                    phone: this.confirmedCustomer.contact.phone
                }
            }
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation UpdateAccountOrganization($input: AccountOrganizationInput!, $orgId: String!) {
                            updateAccountOrganization(input: $input, orgId: $orgId) {
                                complete
                                error
                                success
                                uid
                            }
                        }
                    `,
                    variables: {
                        input: input,
                        orgId: this.$auth.user.org.branchId
                    }
                })
                .then((data) => {
                    if (data && data.data) data.data.confirmedCategories = this.selected
                    this.$emit('submitted', data)
                })
                .catch((e) => {
                    this.$emit('errorSubmit')
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>
